export default  {
  no: 'No',
  yes: 'Yes',
};
